import * as ActionTypes from 'constants';

export const updatePost = post => ({ type: ActionTypes.UPDATE_POST, post});
export const clearPost = f => ({type: ActionTypes.CLEAR_POST});
export const updatePostTitle = title => ({type: ActionTypes.UPDATE_POST_TITLE, value: title})
export const updatePostContent = content => ({type: ActionTypes.UPDATE_POST_CONTENT, value: content});
export const updatePostExcerpt = excerpt => ({type: ActionTypes.UPDATE_POST_EXCERPT, value: excerpt});
export const updatePostSlug = slug => ({type: ActionTypes.UPDATE_POST_SLUG, value: slug});

export const refreshCategories = categories => ({type: ActionTypes.REFRESH_CATEGORIES, value: categories});
export const addPostCategory = category => ({type: ActionTypes.ADD_POST_CATEGORY, value: category});
export const updatePostCategories = categories => ({type: ActionTypes.UPDATE_POST_CATEGORIES, value: categories});
export const removePostCategory = category => ({type: ActionTypes.DELETE_POST_CATEGORY, value: category});



// WEBPACK FOOTER //
// ./src/common/actions/posts.js